import Handler from "../Handler";
class RevealOtherPlayerCardsHandler extends Handler {
  execute(data) {
    let message = JSON.parse(data);
    console.log('REVEALING CARDS FIRST! ', message)
    this.service.processRevealOthersCards(message);
  }
}

export default RevealOtherPlayerCardsHandler;